import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import { AppState } from '../reducers'
import { DirectUploadApi } from '../apis'

@Injectable()
export class DirectUploadService {
  constructor(
    private api: DirectUploadApi,
    private store: Store<AppState>,
  ) {
  }

  upload(file: File): Observable<ActiveStorage.Blob> {
    return this.api.uploadFile(file)
  }
}



// WEBPACK FOOTER //
// ./src/services/direct-upload.ts